const isValidEmail = (str) =>{
    return new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]+$').test(str ? str : '');
}

export default isValidEmail;